import {
  ExclamationTriangleIcon,
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import { DateTime } from "luxon";

const PendingApprovalStrip = ({ appointments = [], onReviewClick }) => {
  if (!appointments || appointments.length === 0) return null;

  const now = DateTime.now();
  const totalCount = appointments.length;
  const pastCount = appointments.filter(
    (a) => DateTime.fromISO(a.startTime) <= now
  ).length;

  return (
    <div className="flex items-center justify-between bg-white rounded-card shadow-hairline border border-ink-100 border-l-4 border-l-signal-amber-500 px-4 py-3">
      <div className="flex items-center gap-x-2.5 min-w-0">
        <ExclamationTriangleIcon className="size-5 text-signal-amber-500 flex-shrink-0" />
        <span className="inline-flex items-center justify-center size-5 rounded-full bg-signal-amber-100 text-xs font-bold text-signal-amber-600 flex-shrink-0">
          {totalCount}
        </span>
        <p className="text-sm font-medium text-ink-900 truncate">
          {totalCount === 1
            ? "1 booking needs approval"
            : `${totalCount} bookings need approval`}
          {pastCount > 0 && (
            <span className="text-ink-400 font-normal">
              {" "}
              (+{pastCount} past)
            </span>
          )}
        </p>
      </div>

      <button
        onClick={onReviewClick}
        className="flex-shrink-0 inline-flex items-center gap-x-1 rounded-pill bg-signal-amber-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-signal-amber-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-signal-amber-500 transition-colors"
      >
        Review
        <ChevronRightIcon className="size-3.5" />
      </button>
    </div>
  );
};

export default PendingApprovalStrip;
